import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import { Form } from '@/components';

export const StyledContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 6rem;
  gap: 2rem;
`;

export const StyledSaveChangesButton = styled(Button)`
  &&& {
    height: 2.5rem;
    background-color: ${COLORS.YELLOW_PRIMARY};
    border-color: transparent;

    &&&:hover {
      background-color: ${COLORS.YELLOW_PRIMARY};
    }
  }
`;

export const StyledContainerTitle = styled.div`
  ${pickThemeFontStyles('20', '30', 'NORMAL')};
  color: ${COLORS.BLACK};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
`;

export const StyledHintText = styled.div`
  color: ${COLORS.RED};
  margin-bottom: 4rem;
`;

export const StyledReadOnlyCategory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 4rem;
`;

export const StyledReadOnlyLabel = styled.span`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.NORMAL_GRAY};
`;

export const StyledReadOnlyValue = styled.span`
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  color: ${COLORS.BLACK};
`;
